export const DEPOSIT_CANCELLED_EVENT = 'app-deposit-cancelled';

export type DepositCancelledDetail = {
  transactionId: string;
  status?: string;
};

export function dispatchDepositCancelled(detail: DepositCancelledDetail): void {
  if (typeof window === 'undefined' || !detail.transactionId) return;
  window.dispatchEvent(new CustomEvent(DEPOSIT_CANCELLED_EVENT, { detail }));
}
